import React from 'react';
import { SdfFocusPane } from '@synerg/react-components';


export default function Confirmation({ setOpenConfirmation, confirmationMessage, onConfirm, onCancel }) {
  return (<SdfFocusPane
    paneType="floating"
    visible={true}
    size="small"
    acceptLabel="Yes"
    dismissLabel="Cancel"
    onSdfDismiss={() => {
      onCancel !== undefined && onCancel();
      setOpenConfirmation(false);
    }}
    onSdfAccept={() => {
      onConfirm();
      setOpenConfirmation(false);
    }}
    closeable={true}
  >
    <span slot="title">Are you sure?</span>
    <div className="text-body-01 mx-6 text-left">
      {confirmationMessage}
    </div>
  </SdfFocusPane >)
};
